import React from 'react'

/**
 * We intend to store the following shape here:
 * - isInteractionLayerHidden {bool}: Whether the layer is visible
 * - tags[string]: InputValues as Taglist
 * @type {React.Context<{}>}
 */
export const ProductSearchContext = React.createContext([{}, () => {}])
